import { atom } from 'recoil';

export const lineAccountIdState = atom<string | null>({
  key: 'lineAccountIdState',
  default: null
});


